import { PlaylistId } from 'constants/enums'

/* eslint-disable prefer-arrow/prefer-arrow-functions */

export const StringUtils = {
    DOUBLE_QUOTES: '&quot;',
    SINGLE_QUOTES: '&apos;',

    urlRegex:
        '(?:(?:https?)://)?((?:[a-zA-Z0-9_][-_a-zA-Z0-9]{0,62}\\.)+(?:[a-zA-Z0-9]{1,10}))',

    /**
     * Determine if the url provided is from the current host
     * @param url
     * @return bool
     */
    isUrlFromCurrentHost(url: string): boolean {
        if (url) {
            const domain = this.getDomain(url)
            // if the url is relative (no domain) or matches the current domain, allow it
            if (!domain || domain == window.location.hostname) {
                return true
            }
        }
        return false
    },

    /**
     * Get the `target` property for a link, based on the target URL
     */
    getHrefTarget(url: string): string {
        if (!this.isUrlFromCurrentHost(url)) {
            return 'target="_blank" rel="noopener"'
        }
        return ''
    },

    /**
     * Get full url from a string (not including query params)
     * @param url
     * @return string
     */
    getUrl(url: string): string {
        if (url) {
            const reg = new RegExp(this.urlRegex)
            const domain = url.match(reg)

            if (domain && domain.length > 0) {
                return domain[0]
            }
        }
        return ''
    },

    /**
     * Get domain name from a string (not including scheme or query params)
     * @param url
     * @return string
     */
    getDomain(url: string): string {
        const reg = new RegExp(this.urlRegex)
        const domain = url.match(reg)

        if (domain && domain.length > 0) {
            return domain[1]
        }
        return ''
    },

    /**
     * Replace Quote strings with entities
     * @param string
     * @return string
     */
    convertQuotesToEntity(string: string): string {
        return string
            .replace(/"/g, this.DOUBLE_QUOTES)
            .replace(/'/g, this.SINGLE_QUOTES)
    },
    /**
     * Remove indentation spaces and new line
     * @param string
     * @return string
     */
    stripMargin(string: string): string {
        return string.replace(/\n\s*/g, '')
    },

    /**
     * Escape a Json string
     * @param string
     * @return string
     */
    escapeJsonString(string: string): string {
        return string
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r')
            .replace(/\t/g, '\\t')
    },

    /**
     * Validate email format
     * @param email
     * ex 'aa@bb.ddd'
     */
    validateEmail: (email: string): boolean => {
        const emailRegExp = new RegExp(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
        return emailRegExp.test(email)
    },

    /**
     * Validate digits only
     * @param text
     * ex '234234'
     */
    validateDigitsOnly: (text: string): boolean => {
        const digitsRegEx = new RegExp(/^\d+$/)
        return digitsRegEx.test(text)
    },

    /**
     * Check if Playlist JW
     * @param string
     * @return boolean
     */
    isPlaylistJw: (id: string): boolean => {
        return id.length === PlaylistId.JW
    }
}
